import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Form,
	Cross,
	FormItem,
	NumberInput,
	Button
} from 'ps-gui';

import {
	getColumnText,
	getPhrase
} from '../data/phrases';
import SystemSettingsModel from './systemsettingsmodel';

const Wrapper = styled.div`
`;

export default class SystemSettingsModule extends ParentBoundComponent {

	constructor() {
		super();
		this.save = this.save.bind(this);
	}

	async save() {
		this.setModel(await this.getModel().save());
	}

	getModel() {
		return new SystemSettingsModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	async componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(await this.getModel().initialize());
		}
	}

	setSessionDuration(loginTypeId, value) {
		this.setModel(this.getModel().setSessionDuration(loginTypeId, value));
	}

	setWarningThreshhold(value) {
		this.setModel(this.getModel().setWarningThreshhold(value));
	}

	// Výpis nadpisu pro každou položku pro loginType
	getFormItemLabel(loginType) {
		return getColumnText('sessionDurationInMinutes') + ' - ' + loginType.get('name');
	}

	render() {
		const model = this.getModel();
		return (
			<Wrapper className="systemSettings">
				<Form vertical virtual>
					<Cross>
						{
							model.getLoginTypes().map(loginType => {
								const id = loginType.get('id');
								return (
									<FormItem label={this.getFormItemLabel(loginType)} key={id} margin="8px">
										<NumberInput
											value={loginType.get('sessionDuration')}
											onChange={value => {
												this.setSessionDuration(id, value);
											}}
										/>
									</FormItem>
								);
							})
						}
					</Cross>
					<Cross>
						<FormItem label={getColumnText('logoutWarningThreshold')} margin="8px" width="calc( 33% - 11px )">
							<NumberInput
								value={model.getWarningThreshhold()}
								placeholder="5"
								onChange={value => this.setWarningThreshhold(value)}
							/>
						</FormItem>
					</Cross>
					<Cross justifyContent="right">
						<Button
							margin="8px"
							text={getPhrase('save')}
							onAction={this.save}
							disabled={!model.isModified()}
						/>
					</Cross>
				</Form>
			</Wrapper>
		);
	}
}

